import { createFileRoute } from '@tanstack/react-router'
import AuditLogList from '@/pages/AuditLog/AuditLogList'
import { RequirePermission } from '@/components/ui/require-permission'

export const Route = createFileRoute('/_authenticated/audit-logs')({
  component: () => (
    <RequirePermission permission='logs.read'>
      <AuditLogList />
    </RequirePermission>
  ),
})
